// extracted by mini-css-extract-plugin
export default {"content":"IndexContent_content__KErda"};